var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"basic":!_vm.client.is_owner}},[(_vm.client.is_owner)?_c('owner-sidebar',{attrs:{"slot":"sidebar"},slot:"sidebar"}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Your Profile")]),_vm._v(" "),(!_vm.client.is_confirmed)?_c('email-needs-confirmation'):_vm._e(),_vm._v(" "),_c('settings')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36298664","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/profile/index.vue
// module id = null
// module chunks = 